export default {
  line1: [
    {
      id: "Taping SOP",
      title: "Taping"
    },
    {
      id: "Manual Handling SOP",
      title: "Manual Handling"
    },
    {
      id: "Kingzip Spacer Block Positioning SOP",
      title: "Kingzip Spacer Block Positioning"
    },
    {
      id: "Block Changes and Cleaning Blocks SOP",
      title: "Block Changes and Cleaning Blocks"
    },
    {
      id: "Re-Work Procedures SOP",
      title: "Re-Work Procedures"
    },
    {
      id: "QMS Data Entry SOP",
      title: "QMS Data Entry"
    },
    {
      id: "Packing & Wrapping Operations SOP",
      title: "Packing & Wrapping Operations"
    },
    {
      id: "Offline Saw Operation Band Saw SOP",
      title: "Offline Saw Operation Band Saw"
    },
    {
      id: "Final Inspection SOP",
      title: "Final Inspection"
    },
    {
      id: "Taping Trap Line Product SOP",
      title: "Taping Trap Line Product"
    },
    {
      id: "QMS Photo App SOP",
      title: "QMS Photo App"
    },
    {
      id: "Fit Inspection SOP",
      title: "Fit Inspection"
    }
  ].sort((a, b) => a.title.localeCompare(b.title)),
  line24: [
    {
      id: "Line 2 Manual De-burring SOP",
      title: "Line 2 Manual De-burring"
    },
    {
      id: "Line 4 Manual De-burring SOP",
      title: "Line 4 Manual De-burring"
    },
    {
      id: "Line 2 Packing & Wrapping Operations SOP",
      title: "Line 2 Packing & Wrapping Operations"
    },
    {
      id: "Line 2 Pallet Operations SOP",
      title: "Line 2 Pallet Operations"
    },
    {
      id: "Line 4 Pallet Operations SOP",
      title: "Line 4 Pallet Operations"
    },
    {
      id: "Re-Work Procedures SOP",
      title: "Re-Work Procedures"
    },
    {
      id: "QMS Data Entry SOP",
      title: "QMS Data Entry"
    },
    {
      id: "Block Changes and Cleaning Blocks SOP",
      title: "Block Changes and Cleaning Blocks"
    },
    {
      id: "Fit Inspection SOP",
      title: "Fit Inspection"
    },
    {
      id: "Packing & Wrapping Operations SOP",
      title: "Packing & Wrapping Operations"
    },
    {
      id: "Manual Handling SOP",
      title: "Manual Handling"
    },
    {
      id: "QMS Photo App SOP",
      title: "QMS Photo App"
    },
    {
      id: "Final Inspection SOP",
      title: "Final Inspection"
    },
    {
      id: "Line 2 Offline Saw - Cutbacks SOP",
      title: "Line 2 Offline Saw - Cutbacks"
    }
  ].sort((a, b) => a.title.localeCompare(b.title)),
  line3: [
    {
      id: "Manual Handling SOP",
      title: "Manual Handling"
    },
    {
      id: "Single Skin Packaging Procedure SOP",
      title: "Single Skin Packaging Procedure"
    },
    {
      id: "Block Changes and Cleaning Blocks SOP",
      title: "Block Changes and Cleaning Blocks"
    },
    {
      id: "Re-Work Procedures SOP",
      title: "Re-Work Procedures"
    },
    {
      id: "QMS Data Entry SOP",
      title: "QMS Data Entry"
    },
    {
      id: "Panel Fit Inspection SOP",
      title: "Panel Fit Inspection"
    },
    {
      id: "Manual Application of P-Gasket SOP",
      title: "Manual Application of P-Gasket"
    },
    {
      id: "QMS Photo App SOP",
      title: "QMS Photo App"
    },
    {
      id: "Foam Saw SOP",
      title: "Foam Saw"
    },
    {
      id: "Taping SOP",
      title: "Taping"
    },
    {
      id: "Final Inspection - Trap Line Product SOP",
      title: "Final Inspection - Trap Line Product"
    },
    {
      id: "Packing & Wrapping Operations SOP",
      title: "Packing & Wrapping Operations"
    }
  ].sort((a, b) => a.title.localeCompare(b.title)),
  shop1: [
    {
      title: "8m Stitching Table",
      id: "8m Stitching Table SOP"
    },
    {
      title: "Benchmark Cranks",
      id: "Benchmark Cranks SOP"
    },
    {
      title: "D-End Area",
      id: "D-End Area SOP"
    },
    {
      title: "Edwards Pearson Guillotine",
      id: "Edwards Pearson Guillotine SOP"
    },
    {
      title: "Edwards Pearson Press",
      id: "Edwards Pearson Press SOP"
    },
    {
      title: "Extrusion Saw",
      id: "Extrusion Saw SOP"
    },
    {
      title: "FK Packing Insulated Gutters",
      id: "FK Packing Insulated Gutters SOP"
    },
    {
      title: "FK Roofing Packaging Requirements",
      id: "FK Roofing Packaging Requirements SOP"
    },
    {
      title: "Folding Table 2",
      id: "Folding Table 2 SOP"
    },
    {
      title: "Hand Tools",
      id: "Hand Tools SOP"
    },
    {
      title: "Hand-Held Banding Machine",
      id: "Hand-Held Banding Machine SOP"
    },
    {
      title: "Horizontal Curves",
      id: "Horizontal Curves SOP"
    },
    {
      title: "Hyma Band Saw",
      id: "Hyma Band Saw SOP"
    },
    {
      title: "Hyma Bevel Saw",
      id: "Hyma Bevel Saw SOP"
    },
    {
      title: "Insulated Gutters",
      id: "Insulated Gutters SOP"
    },
    {
      title: "Meler B4 Adhesive Melter",
      id: "Meler B4 Adhesive Melter SOP"
    },
    {
      title: "Modified Panel",
      id: "Modified Panel SOP"
    },
    {
      title: "Packing",
      id: "Packing SOP"
    },
    {
      title: "Power Panel Process",
      id: "Power Panel Process SOP"
    },
    {
      title: "Rake Saw",
      id: "Rake Saw SOP"
    },
    {
      title: "Rooflight Quality Check",
      id: "Rooflight Quality Check SOP"
    },
    {
      title: "Rooflight System",
      id: "Rooflight System SOP"
    },
    {
      title: "Rooflights DS 0.8 Plus 1.0",
      id: "Rooflights DS 0.8 Plus 1.0 SOP"
    },
    {
      title: "Rooflights U-value 1.0 FAS",
      id: "Rooflights U-value 1.0 FAS SOP"
    },
    {
      title: "Rooflights U-value 1.3 Plus",
      id: "Rooflights U-value 1.3 Plus SOP"
    },
    {
      title: "Rooflights U-value 1.6 FAS",
      id: "Rooflights U-value 1.6 FAS SOP"
    },
    {
      title: "RWM Compact Baler Operation",
      id: "RWM Compact Baler Operation SOP"
    },
    {
      title: "Safe Operation Of Strapex Bander",
      id: "Safe Operation Of Strapex Bander SOP"
    },
    {
      title: "Secret Fix Machine",
      id: "Secret Fix Machine SOP"
    },
    {
      title: "Single Skin Edge Detail Removal",
      id: "Single Skin Edge Detail Removal SOP"
    },
    {
      title: "Spill Containment and Waste Disposal",
      id: "Spill Containment and Waste Disposal SOP"
    },
    {
      title: "Stitching Table 2",
      id: "Stitching Table 2 SOP"
    },
    {
      title: "Stitching Table",
      id: "Stitching Table SOP"
    },
    {
      title: "Top Hat Machine",
      id: "Top Hat Machine SOP"
    },
    {
      title: "Vertical Corners",
      id: "Vertical Corners SOP"
    },
    {
      title: "Vertical Curves",
      id: "Vertical Curves SOP"
    },
    {
      title: "Wall-Lite Operations",
      id: "Wall-Lite Operations SOP"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
